import { RouteEnum } from '@/models/route/Route.model.ts';

export type LeftNavigationBarTranslation = {
  [RouteEnum.CARS]: string;
  [RouteEnum.CHATS]: string;
  [RouteEnum.COMMISSION_ADMINISTRATION]: string;
  [RouteEnum.COMMISSION_CONFIGURATION]: string;
  [RouteEnum.COMMISSIONS]: string;
  [RouteEnum.COMPONENT_DEFINITIONS]: string;
  [RouteEnum.CONTACTS]: string;
  [RouteEnum.CUSTOMERS]: string;
  [RouteEnum.DASHBOARD]: string;
  [RouteEnum.DICTIONARIES]: string;
  [RouteEnum.EMAILS]: string;
  [RouteEnum.EMERGENCY_CONTACTS]: string;
  [RouteEnum.FAILED_WORKFLOW_ACTIONS]: string;
  [RouteEnum.OFFER_DEFINITIONS]: string;
  [RouteEnum.PROCESSES]: string;
  [RouteEnum.RECURRING_RESERVATIONS]: string;
  [RouteEnum.REPORTS]: string;
  [RouteEnum.RESOURCE_CALENDAR]: string;
  [RouteEnum.ROLES]: string;
  [RouteEnum.SUPERVISORS]: string;
  [RouteEnum.SUPPLIERS]: string;
  [RouteEnum.TASKS]: string;
  [RouteEnum.USERS]: string;
};

export const leftNavigationBarTranslation: LeftNavigationBarTranslation = {
  [RouteEnum.CARS]: 'Auta',
  [RouteEnum.CHATS]: 'Czaty',
  [RouteEnum.COMMISSION_ADMINISTRATION]: 'Rozliczenia prowizji',
  [RouteEnum.COMMISSION_CONFIGURATION]: 'Parametry prowizyjne',
  [RouteEnum.COMMISSIONS]: 'Moje prowizje',
  [RouteEnum.COMPONENT_DEFINITIONS]: 'Definicje komponentów',
  [RouteEnum.CONTACTS]: 'Kontakty',
  [RouteEnum.CUSTOMERS]: 'Klienci',
  [RouteEnum.DASHBOARD]: 'Start',
  [RouteEnum.DICTIONARIES]: 'Słowniki',
  [RouteEnum.EMAILS]: 'Poczta',
  [RouteEnum.EMERGENCY_CONTACTS]: 'Kontakty awaryjne',
  [RouteEnum.FAILED_WORKFLOW_ACTIONS]: 'Błędy workflow',
  [RouteEnum.OFFER_DEFINITIONS]: 'Definicje ofert',
  [RouteEnum.PROCESSES]: 'Procesy',
  [RouteEnum.RECURRING_RESERVATIONS]: 'Rezerwacje stałe',
  [RouteEnum.REPORTS]: 'Raporty',
  [RouteEnum.RESOURCE_CALENDAR]: 'Zajętość zasobów',
  [RouteEnum.ROLES]: 'Role i uprawnienia',
  [RouteEnum.SUPERVISORS]: 'Opiekunowie',
  [RouteEnum.SUPPLIERS]: 'Dostawcy',
  [RouteEnum.TASKS]: 'Zadania',
  [RouteEnum.USERS]: 'Konta',
};
